import * as Cookie from 'js-cookie';
import tagManagerHandler from '/Scripts/Handlers/TagManagerHandler';
import stateHandler, { STATE_CHANGED } from '~/Scripts/Handlers/StateHandler';

class CookieSettingsMacro {
    constructor() {
      this.tagManagerHandler = tagManagerHandler;
      this.acceptedCookieName = '';
      this.checkedGroups = [];
      this.onStatusChange = this.onStatusChange.bind(this);
      this.setup();

      stateHandler.on(STATE_CHANGED, this._stateUpdated);
    }
  
    setup() {
      const componentClass = '.js--cookiesettings';
      const element = document.querySelector(componentClass);
  
      if (!element) {
        return;
      }
  
      this.acceptedCookieName = element.attributes['data-cookie-notice-dismissed-name'].value;
      this.defaultCookieGroup = element.attributes['data-default-cookie-group'].value;
      this.setCookieGroups = ['functional'];
  
      const existingCookie = Cookie.get(this.acceptedCookieName);

      // If cookies exist, don't show the cookiebar. 
      // Cookiebar should only be shown if no cookie is set.
      if (existingCookie) {
        this.setCookieGroups = existingCookie.split(",");
        document.querySelector('.js--cookiebar').classList.remove('cookiebar--visible');
      } 
  
      // Set checkbox status based on cookie groups
      if (this.setCookieGroups) {
        document.getElementById('cookie-settings-analytics').checked = this.setCookieGroups.includes('analytical');
      }
    
      element.addEventListener('change', this.onStatusChange);
    }
    
    onStatusChange() {
      // Update checkedGroups based on checkbox status
      this.checkedGroups = [
        'functional',
          document.getElementById('cookie-settings-analytics').checked ? 'analytical' : ''
      ].filter(Boolean); // filter out any empty strings

        const cookieGroups = this.checkedGroups.join(',').replace('"', '');

        Cookie.set(this.acceptedCookieName, cookieGroups, { expires: 365 });

        // Hide the cookie bar if the user toggles the checkbox in the settings
        if (this.checkedGroups.includes('analytical')) {

          const cookieBar = document.querySelector('.js--cookiebar');
          if (cookieBar && cookieBar.classList.contains('cookiebar--visible')) {
            cookieBar.classList.remove('cookiebar--visible');
          }

          if (tagManagerHandler) {
            tagManagerHandler.dispatchAnalyticsEvent(true, 'has_ga_cookie_consent');
          }
        } 
    }

    _stateUpdated = (state) => {

      if (state.cookieConsent === true) {
       
        if (document.getElementById('cookie-settings-analytics') && !document.getElementById('cookie-settings-analytics').checked) {
          document.getElementById('cookie-settings-analytics').checked = true;

          this.onStatusChange();
        }
      }
    }
  }
  
  export default CookieSettingsMacro;